import { dispatchTrackingEventGA4 } from 'common/tracking/dispatchTrackingEventGA4';

const enum Event {
  View = 'picture-text_view',
  Click = 'picture-text_click',
}

const enum Element {
  Button = 'button',
}

export const dispatchPictureTextViewEvent = (type: string, title: string) => {
  dispatchTrackingEventGA4({
    event: Event.View,
    title,
    type,
  });
};

export const dispatchPictureTextClickEvent = (type: string, buttonText: string, title: string) => {
  dispatchTrackingEventGA4({
    event: Event.Click,
    element: Element.Button,
    button_text: buttonText,
    title,
    type,
  });
};
